import { Avatar } from '@material-ui/core'
import { useRouter } from 'next/router'
import List from '../../../../components/list'
import loader from '../../../../components/loader'
import ViewTracker from '../../../../components/tracking/view-tracker'
import { H6, S05, Text } from '../../../../styles/typography'
import dateParser from '../../../../utils/date-time'
import getInitials from '../../../../utils/initials'
import { ReviewsEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Reviews = () => {
  const { asPath } = useRouter()
  const { reviews } = CourseHomeStore.useContainer()

  return loader(
    !reviews.data && !reviews.error,
    Boolean(reviews.error),
    !reviews.data?.length ? null : (
      <ReviewsEl>
        <ViewTracker page={asPath} item='reviews' />

        <H6 className='title'>Student Testimonials:</H6>
        <List
          data={reviews.data || []}
          defaultCount={5}
          item={(review) => (
            <div key={review.id} className='review'>
              <div className='user'>
                <Avatar
                  variant='square'
                  alt={review.userName}
                  src={review.userProfilePic}
                >
                  {getInitials(review.userName)}
                </Avatar>
                <Text>{review.userName}</Text>
              </div>
              <Text className='reviewText'>{review.text}</Text>
              <S05 className='time'>{dateParser.full(review.createdAt)}</S05>
            </div>
          )}
        />
      </ReviewsEl>
    ),
  )
}

export default Reviews
